let StripPrefixDirective = ['ScanConfigService', (ScanConfigService) => {
	return {
		restrict: 'A',
		scope: {
			scanType: '=',
			onPressEnter: '&'
		},
		require: {
			ngModel: 'ngModel'
		},
		link: function (scope, element, attrs, controller) {
			let isEnterCall = false;
			const ENTER_KEY_CODE = 13
			let modelValue;
			const stripPrefix = () => {

				if (controller.ngModel.$modelValue) {
					modelValue = controller.ngModel.$modelValue.trim();
				}

				const scanConfig = ScanConfigService.getScanConfig();

				if (!scanConfig) {
					return;
				}

				if (!controller.ngModel.$modelValue) {
					return;
				}

				const charsToStrip = scanConfig[scope.scanType];

				if (modelValue && charsToStrip) {
					for (let index = 0; index < charsToStrip.length; index++) {
						const charToStrip = charsToStrip[index];

						if (modelValue.toUpperCase().startsWith(charToStrip.toUpperCase())) {

							modelValue = modelValue.substr(1)
							break;
						}
					}

					controller.ngModel.$$rawModelValue = modelValue;
					controller.ngModel.$viewValue = modelValue;
					controller.ngModel.$commitViewValue();
					controller.ngModel.$render()
				}
			}

			element.on('keypress', function (event) {
				if (event.keyCode === ENTER_KEY_CODE && !isEnterCall) {
					isEnterCall = true;
					event.preventDefault();
					event.stopPropagation();
					stripPrefix()

					setTimeout(() => {
						scope.onPressEnter();
					}, 500);
					setTimeout(() => {
						isEnterCall = false;
					}, 1500);	
				}
			})

			// element.on('blur', function () {
			// 	stripPrefix()
			// })
		}
	}
}]

export default StripPrefixDirective;



// WEBPACK FOOTER //
// ./client/app/common/strip-prefix/strip-prefix.directive.js